import { MdOutlineKeyboardDoubleArrowLeft, MdOutlineKeyboardDoubleArrowRight } from "react-icons/md"

const Coverage = () => {
    const data = [
        {
            date: "1/10/2023",
            title: "OUR RIGHT TO DISCONNECT",
            media: "ASIA NEWS TODAY"
        },
        {
            date: "1/10/2023",
            title: "MELP: EMPOWERING YOUTH FOR SUSTAINABLE ENERGY AND ENVIRONMENTAL RESILIENCE",
            media: "ASIA NEWS TODAY"
        },
        {
            date: "2/10/2023",
            title: "EMPOWERING YOUTH FOR AN ENVIRONMENTAL RESILIENT FUTURE",
            media: "APA KHABAR TV"
        },
        {
            date: "5/10/2023",
            title: "SMART-Q UNITEN PUPUK BUDAYA MENGAJI AL-QURAN, JALIN KERJASAMA DENGAN KOMUNITI SETEMPAT",
            media: "SINAR HARIAN"
        },
        {
            date: "5/10/2023",
            title: "KAFE BANTU TINGKAT SUMBER EKONOMI MASJID",
            media: "GPS BESTARI"
        },
        {
            date: "5/10/2023",
            title: "KAFE BANTU TINGKAT SUMBER EKONOMI MASJID",
            media: "SINAR HARIAN ONLINE"
        },
        {
            date: "5/10/2023",
            title: "KAFE BANTU TINGKAT SUMBER EKONOMI MASJID",
            media: "THEVIBES"
        },

    ]
    return (
        <div className="relative bg-white  py-8 text-black w-full md:px-32 p-6 flex flex-col items-start justify-center ">

            <h1 className=" text-slate-900 text-2xl sm:text-4xl font-bold ">Media Coverage 2023</h1>
            <div className="py-8 flex flex-col  gap-5">
                <span className={`uppercase flex gap-1 items-center justify-start w-fit  text-xs  font-bold text-cyan-600`}> <MdOutlineKeyboardDoubleArrowLeft /> NOVEMBER  OCTOBER  SEPTEMBER <MdOutlineKeyboardDoubleArrowRight /></span>
                <div className="w-full overflow-x-auto scroll-bar p-2">
                    <table className="w-full  table-fixed border">
                        <thead>
                            <tr className="text-left bg-indigo-100">
                                <th className="p-4">Date</th>
                                <th className="p-4">Title</th>
                                <th className="p-4">Media</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                data.map((item, index) => {
                                    return (
                                        <tr key={index} className={`border-b border-neutral-200 ${index % 2 === 0 && "bg-slate-50"} font-semibold`}>
                                            <td className="p-4">{item.date}</td>
                                            <td className="p-4">{item.title}</td>
                                            <td className="p-4 text-cyan-600">{item.media}</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>

            </div>

        </div>
    )
}

export default Coverage